import * as React from 'react';
import { memo } from 'react';
const SvgLogo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="146px"
    height="33px"
    viewBox="0 0 146 33"
    {...props}
  >
    <g id="surface1">
      <path
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: 'rgb(10.196078%,19.607843%,13.72549%)',
          fillOpacity: 1,
        }}
        d="M 92.820312 6.777344 L 88.574219 6.777344 L 88.574219 23.238281 L 100.039062 23.238281 L 100.039062 19.667969 L 92.820312 19.667969 Z M 92.820312 6.777344 "
      />
      <path
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: 'rgb(10.196078%,19.607843%,13.72549%)',
          fillOpacity: 1,
        }}
        d="M 107.476562 6.777344 L 101.28125 23.238281 L 105.671875 23.238281 L 106.796875 20.011719 L 112.210938 20.011719 L 113.355469 23.238281 L 117.722656 23.238281 L 111.527344 6.800781 L 107.476562 6.800781 Z M 108.015625 16.535156 L 109.503906 12.253906 L 110.992188 16.535156 Z M 108.015625 16.535156 "
      />
      <path
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: 'rgb(10.196078%,19.607843%,13.72549%)',
          fillOpacity: 1,
        }}
        d="M 129.308594 14.238281 C 129.820312 13.96875 130.261719 13.527344 130.601562 12.941406 C 130.96875 12.355469 131.136719 11.71875 131.136719 10.984375 C 131.136719 9.664062 130.625 8.609375 129.625 7.875 C 128.601562 7.144531 127.332031 6.75 125.773438 6.75 L 118.894531 6.75 L 118.894531 23.191406 L 125.894531 23.191406 C 127.722656 23.191406 129.1875 22.75 130.332031 21.894531 C 131.480469 21.039062 132.039062 19.816406 132.039062 18.25 C 132.039062 17.269531 131.796875 16.4375 131.261719 15.753906 C 130.773438 15.09375 130.113281 14.578125 129.308594 14.238281 Z M 123.066406 10.03125 L 125.332031 10.03125 C 126.648438 10.03125 127.308594 10.496094 127.308594 11.449219 C 127.308594 11.890625 127.164062 12.230469 126.84375 12.476562 C 126.527344 12.71875 126.066406 12.84375 125.429688 12.84375 L 123.066406 12.84375 Z M 127.503906 19.253906 C 127.113281 19.519531 126.480469 19.667969 125.601562 19.667969 L 123.066406 19.667969 L 123.066406 16.316406 L 125.625 16.316406 C 126.503906 16.316406 127.136719 16.464844 127.527344 16.730469 C 127.917969 17.027344 128.113281 17.464844 128.113281 18.003906 C 128.113281 18.542969 127.917969 18.984375 127.503906 19.253906 Z M 127.503906 19.253906 "
      />
      <path
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: 'rgb(10.196078%,19.607843%,13.72549%)',
          fillOpacity: 1,
        }}
        d="M 145.210938 15.410156 C 144.699219 14.726562 144.089844 14.261719 143.382812 13.96875 C 142.675781 13.675781 141.773438 13.453125 140.675781 13.234375 C 139.96875 13.085938 139.433594 12.964844 139.042969 12.84375 C 138.652344 12.71875 138.335938 12.550781 138.089844 12.304688 C 137.847656 12.058594 137.699219 11.765625 137.699219 11.375 C 137.699219 11.007812 137.871094 10.714844 138.1875 10.496094 C 138.503906 10.273438 138.917969 10.152344 139.457031 10.152344 C 140.113281 10.152344 140.625 10.296875 141.015625 10.617188 C 141.40625 10.933594 141.628906 11.351562 141.675781 11.890625 L 145.628906 11.890625 C 145.601562 10.8125 145.335938 9.882812 144.824219 9.101562 C 144.308594 8.292969 143.578125 7.679688 142.652344 7.242188 C 141.722656 6.800781 140.652344 6.582031 139.433594 6.582031 C 138.308594 6.582031 137.308594 6.777344 136.429688 7.191406 C 135.554688 7.609375 134.871094 8.171875 134.359375 8.90625 C 133.871094 9.636719 133.601562 10.46875 133.601562 11.375 C 133.601562 12.621094 133.871094 13.625 134.382812 14.335938 C 134.894531 15.042969 135.527344 15.558594 136.234375 15.851562 C 136.96875 16.144531 137.871094 16.414062 138.96875 16.660156 C 139.917969 16.855469 140.625 17.074219 141.089844 17.296875 C 141.53125 17.515625 141.75 17.859375 141.75 18.347656 C 141.75 18.8125 141.554688 19.152344 141.1875 19.449219 C 140.820312 19.71875 140.308594 19.863281 139.675781 19.863281 C 138.96875 19.863281 138.382812 19.644531 137.945312 19.226562 C 137.503906 18.8125 137.261719 18.273438 137.210938 17.5625 L 133.1875 17.5625 C 133.210938 18.738281 133.503906 19.765625 134.066406 20.644531 C 134.625 21.527344 135.382812 22.210938 136.332031 22.703125 C 137.308594 23.191406 138.40625 23.410156 139.675781 23.410156 C 140.945312 23.410156 142.042969 23.191406 142.992188 22.773438 C 143.945312 22.359375 144.675781 21.746094 145.1875 20.988281 C 145.699219 20.207031 145.96875 19.300781 145.96875 18.273438 C 145.992188 17.050781 145.726562 16.097656 145.210938 15.410156 Z M 145.210938 15.410156 "
      />
      <path
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: 'rgb(10.196078%,19.607843%,13.72549%)',
          fillOpacity: 1,
        }}
        d="M 69.574219 23.214844 L 81.792969 23.214844 L 81.792969 19.644531 L 73.792969 19.644531 L 73.792969 16.632812 L 79.941406 16.632812 L 79.941406 13.0625 L 73.792969 13.0625 L 73.792969 10.324219 L 81.792969 10.324219 L 81.792969 6.75 L 69.574219 6.75 Z M 69.574219 23.214844 "
      />
      <path
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: 'rgb(10.196078%,19.607843%,13.72549%)',
          fillOpacity: 1,
        }}
        d="M 41.496094 6.582031 C 36.523438 6.582031 32.886719 10.152344 32.886719 14.996094 C 32.886719 19.839844 36.523438 23.410156 41.496094 23.410156 C 46.472656 23.410156 50.109375 19.839844 50.109375 14.996094 C 50.109375 10.152344 46.425781 6.582031 41.496094 6.582031 Z M 41.496094 19.839844 C 38.914062 19.839844 37.105469 17.761719 37.105469 14.996094 C 37.105469 12.230469 38.914062 10.152344 41.496094 10.152344 C 44.082031 10.152344 45.886719 12.230469 45.886719 14.996094 C 45.886719 17.785156 44.058594 19.839844 41.496094 19.839844 Z M 41.496094 19.839844 "
      />
      <path
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: 'rgb(10.196078%,19.607843%,13.72549%)',
          fillOpacity: 1,
        }}
        d="M 62.476562 16.609375 L 56.425781 6.75 L 51.984375 6.75 L 51.984375 23.214844 L 56.183594 23.214844 L 56.183594 13.382812 L 62.230469 23.214844 L 66.671875 23.214844 L 66.671875 6.75 L 62.476562 6.75 Z M 62.476562 16.609375 "
      />
      <path
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: 'rgb(10.196078%,19.607843%,13.72549%)',
          fillOpacity: 1,
        }}
        d="M 18.59375 28.742188 L 0.0078125 28.742188 L 0.0078125 33 L 23.472656 33 L 23.472656 23.238281 L 18.59375 23.238281 Z M 18.59375 28.742188 "
      />
      <path
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: 'rgb(10.196078%,19.607843%,13.72549%)',
          fillOpacity: 1,
        }}
        d="M 3.496094 11.179688 C 5.933594 10.984375 7.910156 10.226562 9.421875 9.199219 L 9.421875 23.238281 L 14.300781 23.238281 L 14.300781 0 L 10.375 0 C 10.203125 0.976562 9.886719 1.859375 9.472656 2.617188 C 8.933594 3.597656 8.300781 4.574219 7.347656 5.160156 C 6.277344 5.992188 4.859375 6.410156 3.152344 6.53125 C 2.859375 6.554688 2.542969 6.554688 2.25 6.554688 C 1.421875 6.554688 0.738281 6.554688 0.0078125 6.484375 L 0.0078125 10.960938 C 0.0546875 10.984375 0.078125 10.984375 0.128906 10.984375 C 1.25 11.203125 2.371094 11.277344 3.496094 11.179688 Z M 3.496094 11.179688 "
      />
    </g>
  </svg>
);
const Memo = memo(SvgLogo);
export default Memo;
